module.exports = globalThis.React